import React, { memo } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

// images
import icon_cancel_dialog from "assets/icon_cancel_dialog.png";

const Header = memo(
  ({
    className,
    rightComponent,
    title,
    styleIconBack,
    customStyle,
    onBack,
  }) => {
    const navigate = useNavigate();

    return (
      <div className={className} style={customStyle}>
        <div
          onClick={() => {
            onBack ? onBack() : navigate(-1);
          }}
          style={styleIconBack}
        >
          <img
            className="arrow-back w-6 py-2"
            src={icon_cancel_dialog}
            alt="icon dot"
          />
        </div>
        <div className="font-700 fs-16">{title}</div>
        {rightComponent ? <div>{rightComponent}</div> : <div className="w-4" />}
      </div>
    );
  }
);

export default styled(Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
`;
